import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';

/**
 * - 찜 서랍 페이지로 이동
 */
export const useMoveToLikeFolders = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    ({ folderSno }: { folderSno: number }) => {
      openDeeplink(`ably://like/folders/${folderSno}`);
    },
    [openDeeplink],
  );
};
